import React, { Fragment, useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { ProjectBlog, titleBlog } from "../Fasto/Home/IndexData";
import { Spinner } from "react-bootstrap";
const Index = () => {
  const { changeBackground, background } = useContext(ThemeContext);

  const [titleData, setTitleData] = useState([]);
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    setSpinner(true);
    changeBackground({ value: "light", label: "Light" });

    axios
      .get(`${Baseurl.baseurl}/admin/get-homepage-data`)
      .then((res) => {

        titleBlog[0].title = res.data.totalUserCount;
        titleBlog[1].title = res.data.totalRiderCount;
        titleBlog[2].title = res.data.totalProcessingOrderCount;
        titleBlog[3].title = res.data.totalCancelledOrderCount;
        titleBlog[4].title = res.data.totalBlockedRiderCount;
        titleBlog[5].title = res.data.totalAcceptedOrderCount;
        titleBlog[6].title = res.data.totalOrderCount;
        titleBlog[7].title = res.data.totalOngoingOrderCount;
        titleBlog[8].title = res.data.totalActiveUserCount;
        titleBlog[9].title = res.data.totalPendingOrderCount;
        setTitleData(titleBlog);
        setSpinner(false);
      });
  }, []);

  return (
    <Fragment>
      {spinner ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div className="row">
          {titleData.map((item, index) => (
            <div className="col-xl-3 col-xxl-6 col-lg-6 col-sm-6" key={index}>
              <div className="card card-bd">
                {item.border}
                <div
                  style={{ backgroundColor: "#135334" }}
                  className="card-body"
                >
                  <div className="media align-items-center">
                    <div className="media-body mr-3">
                      <h2 className="num-text text-white font-w700">
                        {item.title}
                      </h2>
                      <span className="fs-14 text-white">{item.subtitle}</span>
                    </div>
                    {item.icon}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Fragment>
  );
};
export default Index;
